export default __webpack_public_path__ + "static/media/la_capelle3.4f22e221.jpg";